import React from 'react'
import reactStamp from 'react-stamp'
import './background.css'

export default reactStamp(React).compose({

    render() {
        return (
            <div className="page">
                <div id="rectangle_2"></div>
                <div id="rectangle_1"></div>
                <div id="back"></div>
            </div>
        )
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Background/index.js
 **/